<template>

    <common-table :table-columns="tableColumns" :url="url" :operate="operate" :form-fields="formFields" :permission="permission" :searchs="searchs" ref="table"></common-table>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "LivePublishPlanGroup",
        components: {CommonTable},
        data(){
            return {
                searchs:[
                    {
                        name: 'groupId',
                        placeholder: '计划组ID',
                        type: 'input'
                    },
                    {
                        name: 'name',
                        placeholder: '计划组名称',
                        type: 'input'
                    },
                    {
                        name: 'flowCode',
                        placeholder: '流程编码',
                        type: 'input'
                    },
                    {
                        name: 'mode',
                        placeholder: '触发模式',
                        type: 'select',
                        selectValue: [{key:'once', value:'once'},{key:'schedule', value:'schedule'},{key:'loop', value:'loop'}]
                    },
                    {
                        name: 'enabled',
                        placeholder: '状态',
                        type: 'select',
                        selectValue: [{key:true, value:'启用'},{key:false, value:'禁用'}]
                    }
                ],
                permission:{
                    add: 'livePublishPlanGroup:add',
                    update: 'livePublishPlanGroup:update',
                    delete: 'livePublishPlanGroup:delete',
                    deleteBatch: 'livePublishPlanGroup:deleteBatch'
                },
                url: {
                    get: '/livePublish/planGroup/listByCondition',
                    add: '/livePublish/planGroup/add',
                    update: '/livePublish/planGroup/update',
                    delete: '/livePublish/planGroup/delete/',
                    delete_batch: '/livePublish/planGroup/deleteBatch'
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '75',
                }, {
                    field: 'groupId',
                    label: '计划组ID',
                    show: true,
                    width: '',
                }, {
                    field: 'userId',
                    label: '用户ID',
                    show: true,
                    width: '',
                }, {
                    field: 'name',
                    label: '计划组名称',
                    show: true,
                    width: '',
                }, {
                    field: 'flowCode',
                    label: '流程编码',
                    show: true,
                    width: '',
                }, {
                    field: 'mode',
                    label: '触发模式',
                    show: true,
                    width: '100',
                }, {
                    field: 'enabled',
                    label: '状态',
                    show: true,
                    width: '80',
                }, {
                    field: 'timezone',
                    label: '时区',
                    show: true,
                    width: '',
                }, {
                    field: 'startAt',
                    label: '开始时间',
                    show: true,
                    width: '',
                }],
                operate: [
                    { name: 'edit', label: '编辑', type: 'text' },
                    { name: 'delete', label: '删除', type: 'text' }
                ],
                formFields: {
                    addTitle: '添加计划组',
                    updateTitle: '修改计划组',
                    model: [
                        { label: '计划组ID', name: 'groupId', type: 'input', required: true, placeholder: '请输入计划组ID' },
                        { label: '用户ID', name: 'userId', type: 'input', required: true, placeholder: '请输入用户ID' },
                        { label: '计划组名称', name: 'name', type: 'input', required: true, placeholder: '请输入计划组名称' },
                        { label: '流程编码', name: 'flowCode', type: 'input', required: true, placeholder: '请输入流程编码' },
                        { label: '触发模式', name: 'mode', type: 'select', required: true, placeholder: '请选择触发模式', selectValue: [{key:'once', value:'once'},{key:'schedule', value:'schedule'},{key:'loop', value:'loop'}] },
                        { label: '状态', name: 'enabled', type: 'switch', required: false, placeholder: '' },
                        { label: '时区', name: 'timezone', type: 'input', required: false, placeholder: '请输入时区' },
                        { label: '开始时间', name: 'startAt', type: 'dateTime', required: false, placeholder: '请选择开始时间' }
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>
